'use strict';

var util = angular.module('gymsystem.util');

util.directive('economyaddtransaction', ['$modal', function($modal) {
    return {
        restrict: 'E',
        template: '<button class="btn btn-success btn-block-mobile" ng-click="addTransactionEntry()">{{\'Add transaction\'|translate}}</button>',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.addTransactionEntry = function() {
                $modal.open({
                    templateUrl: 'views/addtransactionentrymodal.html',
                    controller: 'AddTransactionEntryModalCtrl'
                });
            };
        }
    };
}]);
